namespace TabAurous.Master {
    export namespace EmployeeMasterService {
        export const baseUrl = 'Master/EmployeeMaster';

        export declare function Create(request: Serenity.SaveRequest<EmployeeMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<EmployeeMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<EmployeeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<EmployeeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetActiveEmployees(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<EmployeeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Master/EmployeeMaster/Create",
            Update = "Master/EmployeeMaster/Update",
            Delete = "Master/EmployeeMaster/Delete",
            Retrieve = "Master/EmployeeMaster/Retrieve",
            List = "Master/EmployeeMaster/List",
            GetActiveEmployees = "Master/EmployeeMaster/GetActiveEmployees"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetActiveEmployees'
        ].forEach(x => {
            (<any>EmployeeMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
